import * as React from 'react';
import {navigateTo, route, linkTo} from '../links';
import * as orderService from "../webServices/orderService"
import { Page } from './base/page';
import { MaxWidthIsland, FormIsland } from '../ap/pages/sections';
import { DocumentSightingStepper, DocumentSightingStep } from './components/appStepper';

import { appState } from "../state/state"
import { config } from '../config/config';
import { Status } from './components/notificationBar';
import { trackPaymentPage, trackPaymentSuccessfulPage } from '../ap/omniture/omnitureService';
import {Securepay} from "./components/securepay";


const {voi} = appState;


interface PaymentPageProps {
}

interface PaymentPageState {
}

export class PaymentPage extends React.Component<PaymentPageProps, PaymentPageState> {

  securepayComp;

  constructor(props) {
    super(props);
    this.state = {};

  }

  submitPayment(tokenizedCard) {
    let orderId = voi.orderId;
    let promise = orderService.pay({orderId: orderId, token: tokenizedCard.token, customerId: tokenizedCard.customer});
    promise.then((response) => {
      voi.reset();
      voi.transactionStatus.value = Status.success;
      trackPaymentSuccessfulPage(voi.categorySelectField, response.orderFiles, response.cost, response.referenceId);
      navigateTo(route.registerNew());
    });

    promise.catch((error) => {

      let response = error.response;

      if (response.status == 500) {
        this.abortPayment();
        return;
      }

      if (response.status == 400) {
        response.json().then((jsonBody) => {
          let errorMessage = jsonBody.errors[0].detail;
          this.retryPayment(errorMessage);
        });
        return;
      }
    });

  }

  retryPayment(errorMessage){
    this.securepayComp.paymentErrorAlert(errorMessage);
  }


  abortPayment(){
    voi.transactionStatus.value = Status.failure;
    navigateTo(route.registerNew());
  }

  processTokenizeError(errorResponse) {
    // This is the temp securepay fix for front end validation error.
    // Don't be angry, the securepay response itself has double quote in it!!
    let messageToCompare = '"Form data is invalid"'
    if(errorResponse == messageToCompare){
      return;
    }

    let errorCode;

    try{
      errorCode = errorResponse.errors[0].code;
    }catch (error){
      this.abortPayment();
      return;
    }

    if(errorCode == "INVALID_CARD_DETAILS") {
      return;
    }

    if (errorCode == "PRE_AUTH_FAILED") {
      this.retryPayment("The credit card details are not valid. Please re-enter.");
      return;
    }

    this.abortPayment();

  }

  componentDidMount() {
    trackPaymentPage();
  }
  render() {
    const sections = [
      <MaxWidthIsland>
        <DocumentSightingStepper current={DocumentSightingStep.Payment} />
      </MaxWidthIsland>,
      <FormIsland>
        <Securepay
          ref={(thisSecurepayComp) => { this.securepayComp = thisSecurepayComp; }}
          clientId={config.securepay.clientId}
          merchantCode= {config.securepay.merchantCode}
          scriptUrl={config.securepay.scriptUrl}
          allowedCardTypes={['visa', 'mastercard']}
          onFormValidityChange={(valid) => {
          }}
          onTokenizeSuccess={(tokenizedCard) => {
            this.submitPayment(tokenizedCard);
          }}
          onTokenizeError={(errorResponse?: string) => {
            this.processTokenizeError(errorResponse);
          }}
          onLoadError={() => {
            this.abortPayment();
          }}
          servicePrice={config.servicePrice}
          cancelUrl={linkTo(route.cancel())}
        />
      </FormIsland>
    ]

    return (
      <Page
        loggedIn={true}
        sections={sections}
      />
    );
  }

}
